"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterMenuHeader = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
const View_1 = require("../../../View");
exports.FilterMenuHeader = (0, react_1.memo)(({ title, children }) => (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, size: { height: helpers_1.SIZE_XL }, indentBottom: View_1.INDENT.s, gap: StackView_1.STACK_GAP.m, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
    react_1.default.createElement(Text_1.Text, { weight: Text_1.TEXT_WEIGHT.bold }, title),
    children && react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center }, children))));
exports.FilterMenuHeader.displayName = 'FilterMenuHeader';
//# sourceMappingURL=FilterMenuHeader.js.map